import { bl_fi_mst_ledger_hdr_RowClass } from '../../../dbschema/bl_fi_mst_ledger_hdr.model';
import { bl_fi_mst_ledger_ext_RowClass } from '../../../dbschema/bl_fi_mst_ledger_ext.model';
import {BaseContainerModel} from '../../base-container.model';


export class LedgerContainerModel extends BaseContainerModel {
  bl_fi_mst_ledger_hdr: bl_fi_mst_ledger_hdr_RowClass = new bl_fi_mst_ledger_hdr_RowClass();
  bl_fi_mst_ledger_exts: bl_fi_mst_ledger_ext_RowClass[] = [];
}
